/* ══════════════════════════════════════════════════════════════════════════
   STABILCOINOK A HŐTÉRKÉPEN (Terminál-javítások 1. kör, A.7)
   ─────────────────────────────────────────────────────────────────────────
   A dollárhoz vagy euróhoz kötött stabilcoinok kimaradnak a Hőtérképről (a
   mozgásuk ~0, csak helyet foglalnának). Két lista:
   - STABLE_IDS: CoinGecko-azonosító szerint (biztos: a szimbólum ütközhet, pl.
     „u”, „cash”). Forrás: a CoinGecko „stablecoins” kategóriája és a terminál
     top 250-e, 2026-11-01; ami dollárhoz vagy euróhoz kötött.
   - STABLE_SYMS: a korábbi, szimbólum szerinti lista (tartalék).
   Nem stabilcoin itt: az aranyhoz kötött tokenek (XAUT, PAXG; az áruk mozog), a nem
   dollár/euró alapúak (A7A5 rubel, JPYC, JPYSC jen), és a tokenizált alapok és
   hitelpapírok (pl. BUIDL, Spiko-alap, THBILL, SSTN-ek), a hozamgyűjtő apyUSD sem.
   A kategórialista napi szerveroldali lekérése a landing market-cache függvényét
   kívánná; ez a kör csak a terminált érinti, ezért rögzített lista.
   ══════════════════════════════════════════════════════════════════════════ */

export const STABLE_SYMS = new Set([
  'usdt','usdc','busd','dai','tusd','usds','usdg','usde','usdy','usdp','pyusd','usdd','fdusd','gusd','frax','cusd','alusd',
]);

export const STABLE_IDS = new Set([
  // a korábbi lista elemei azonosítóval is
  'tether', 'usd-coin', 'usds', 'dai', 'ethena-usde', 'global-dollar', 'paypal-usd', 'usdd', 'true-usd', 'first-digital-usd',
  'frax', 'gusd', 'binance-usd', 'paxos-standard', 'gemini-dollar',
  // új, a 2026-11-01-i top 250-ből (dollár)
  'usd1-wlfi', 'ripple-usd', 'falcon-finance', 'united-stables', 'bfusd', 'usdgo', 'open-usd', 'gho', 'usual-usd', 'ylds',
  're-protocol-reusd', 'apxusd', 'sofiusd', 'usx', 'usa', 'crvusd', 'agora-dollar', 'cash-4', 'avant-usd',
  'usdai',   // dollárhoz kötött, de a CoinGecko nem sorolja a kategóriába
  // euró
  'euro-coin', 'societe-generale-forge-eurcv',
]);

export const isStablecoin = (c) => !!c && (STABLE_IDS.has(c.id) || STABLE_SYMS.has(String(c.symbol || '').toLowerCase()));
